import _objectSpread from "E:/workspace/ysorder/order_admin_client/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import "core-js/modules/es.object.keys.js";
import facebookFillSVG from "@/assets/facebook-fill.svg";
import gongzhonghaoSVG from "@/assets/gongzhonghao.svg";
import instagramFillSVG from "@/assets/instagram-fill.svg";
import pinterestpinterest30SVG from "@/assets/pinterestpinterest30.svg";
import snapchatSVG from "@/assets/snapchat.svg";
import tumblrSVG from "@/assets/tumblr.svg";
import twitterSVG from "@/assets/twitter.svg";
import vimeoSVG from "@/assets/vimeo.svg";
import youtubeFillSVG from "@/assets/Youtube-fill.svg";
import weiboSVG from "@/assets/weibo.svg";
import lineSVG from "@/assets/line.svg";
import YYImage from "@/pages/design/components/basic/image";
import { mapState } from "vuex";
import { handleHoverColorEnter, handleHoverColorLeave } from "@/pages/design/common/utils";
export default {
  props: {
    formData: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  components: {
    YYImage: YYImage
  },
  data: function data() {
    return {
      defaultLangId: 0,
      icons: {
        Facebook: facebookFillSVG,
        公众号: gongzhonghaoSVG,
        Instagram: instagramFillSVG,
        Pinterest: pinterestpinterest30SVG,
        Snapchat: snapchatSVG,
        Tumblr: tumblrSVG,
        Twitter: twitterSVG,
        Vimeo: vimeoSVG,
        YouTube: youtubeFillSVG,
        Weibo: weiboSVG,
        Line: lineSVG
      }
    };
  },
  created: function created() {
    // console.log('datas', this.datas)
    var defaultLangObjStr = window.localStorage.cdefaultLangObj ? window.localStorage.cdefaultLangObj : window.localStorage.defaultLangObj;
    var defaultLangObj = JSON.parse(defaultLangObjStr);
    // let defaultLangObj = JSON.parse(localStorage.defaultLangObj);
    if (defaultLangObj) {
      this.defaultLangId = defaultLangObj.langId;
    }
  },
  computed: _objectSpread(_objectSpread({}, mapState({
    imgHost: function imgHost(state) {
      return state.design.imgHost;
    }
  })), {}, {
    custominfo: function custominfo() {
      // console.log('custominfo', this.formData.data.custominfo)
      return this.formData.data.custominfo;
    }
  }),
  methods: {
    handleHoverColorEnter: handleHoverColorEnter,
    handleHoverColorLeave: handleHoverColorLeave,
    handleIconMouseEnter: function handleIconMouseEnter(name, color, i) {
      this.iconColor = this.$refs[name][i].$el.style.color;
      this.$refs[name][i].$el.style.color = color;
    },
    handleIconMouseLeave: function handleIconMouseLeave(name, i) {
      this.$refs[name][i].$el.style.color = this.iconColor;
    },
    handleShareIconEnter: function handleShareIconEnter(e, item) {
      e.target.src = item.actpic;
      // console.log('e,item', e, item)
    },
    handleShareIconLeave: function handleShareIconLeave(e, item) {
      e.target.src = item.defpic;
    }
  }
};